module.exports = __webpack_public_path__ + "static/media/potential.9eea72de.svg";